import { useMemo, useState, type ReactNode } from 'react';

import { ReportTurnContext, type TurnSavedReport } from './reportTurn';

/**
 * One per turn, so the table card can be scheduled once its report is saved: a schedule
 * reopens `/reports?run=<id>`, which re-runs the saved recipe and renders the same table.
 */
export function ReportTurnProvider({
    initial,
    editingReport,
    onSaved,
    children,
}: {
    initial: TurnSavedReport | null;
    editingReport: TurnSavedReport | null;
    onSaved: (savedReport: TurnSavedReport) => void;
    children: ReactNode;
}) {
    const [savedReport, setSavedReportState] = useState<TurnSavedReport | null>(initial);
    const value = useMemo(
        () => ({
            savedReport,
            setSavedReport: (next: TurnSavedReport) => {
                setSavedReportState(next);
                onSaved(next);
            },
            editingReport,
        }),
        [savedReport, editingReport, onSaved],
    );
    return <ReportTurnContext.Provider value={value}>{children}</ReportTurnContext.Provider>;
}
